module.exports = __webpack_public_path__ + "39fa54223388b81d0844d10aac09239f.svg";